import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideInitialAuthCallback } from './core/auth/auth-callback.initializer';
import { authInterceptor } from './core/auth/auth.interceptor';
import {
  CaseDocumentsApi,
  KpmCaseDocumentsApi,
} from './features/cases/documents/case-documents.api';
import {
  CaseFinancialsApi,
  KpmCaseFinancialsApi,
} from './features/cases/financials/case-financials.api';
import {
  CaseRelatedApi,
  KpmCaseRelatedApi,
} from './features/cases/related/case-related.api';
import {
  CaseTasksApi,
  KpmCaseTasksApi,
} from './features/cases/tasks/case-tasks.api';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(provideInitialAuthCallback()),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor])),
    // KPM2-104: bind the abstract case-tasks data seam to its real
    // implementation app-wide. The Kanban board (KPM2-105) consumes the same
    // token; a preview harness overrides it locally with a stub.
    { provide: CaseTasksApi, useExisting: KpmCaseTasksApi },
    // KPM2-107: bind the abstract case-documents data seam to its real impl.
    { provide: CaseDocumentsApi, useExisting: KpmCaseDocumentsApi },
    // KPM2-108: bind the abstract case-financials data seam to its real impl.
    { provide: CaseFinancialsApi, useExisting: KpmCaseFinancialsApi },
    // KPM2-108: bind the abstract case-related data seam to its real impl.
    { provide: CaseRelatedApi, useExisting: KpmCaseRelatedApi },
  ],
};